function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

(function (t, e) {
  "object" === (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" === (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = e(require("vue")) : "function" === typeof define && define.amd ? define(["vue"], e) : "object" === (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports["vue-slider-component"] = e(require("vue")) : t["vue-slider-component"] = e(t["Vue"]);
})("undefined" !== typeof self ? self : this, function (t) {
  return function (t) {
    var e = {};

    function r(n) {
      if (e[n]) return e[n].exports;
      var o = e[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return t[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }

    return r.m = t, r.c = e, r.d = function (t, e, n) {
      r.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (t) {
      "undefined" !== typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, r.t = function (t, e) {
      if (1 & e && (t = r(t)), 8 & e) return t;
      if (4 & e && "object" === _typeof(t) && t && t.__esModule) return t;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var o in t) {
        r.d(n, o, function (e) {
          return t[e];
        }.bind(null, o));
      }
      return n;
    }, r.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t["default"];
      } : function () {
        return t;
      };
      return r.d(e, "a", e), e;
    }, r.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, r.p = "", r(r.s = "fb15");
  }({
    "091b": function b(t, e, r) {
      var n = r("24fb");
      e = n(!1), e.push([t.i, ".vue-slider-dot{position:absolute;-webkit-transition:all 0s;transition:all 0s;z-index:5}.vue-slider-dot:focus{outline:none}.vue-slider-dot-tooltip{position:absolute;visibility:hidden}.vue-slider-dot-hover:hover .vue-slider-dot-tooltip,.vue-slider-dot-tooltip-show{visibility:visible}.vue-slider-dot-tooltip-top{top:-10px;left:50%;-webkit-transform:translate(-50%,-100%);transform:translate(-50%,-100%)}.vue-slider-dot-tooltip-bottom{bottom:-10px;left:50%;-webkit-transform:translate(-50%,100%);transform:translate(-50%,100%)}.vue-slider-dot-tooltip-left{left:-10px;top:50%;-webkit-transform:translate(-100%,-50%);transform:translate(-100%,-50%)}.vue-slider-dot-tooltip-right{right:-10px;top:50%;-webkit-transform:translate(100%,-50%);transform:translate(100%,-50%)}", ""]), t.exports = e;
    },
    "24fb": function fb(t, e, r) {
      "use strict";

      function n(t, e) {
        var r = t[1] || "",
            n = t[3];
        if (!n) return r;

        if (e && "function" === typeof btoa) {
          var i = o(n),
              a = n.sources.map(function (t) {
            return "/*# sourceURL=".concat(n.sourceRoot || "").concat(t, " */");
          });
          return [r].concat(a).concat([i]).join("\n");
        }

        return [r].join("\n");
      }

      function o(t) {
        var e = btoa(unescape(encodeURIComponent(JSON.stringify(t)))),
            r = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(e);
        return "/*# ".concat(r, " */");
      }

      t.exports = function (t) {
        var e = [];
        return e.toString = function () {
          return this.map(function (e) {
            var r = n(e, t);
            return e[2] ? "@media ".concat(e[2], " {").concat(r, "}") : r;
          }).join("");
        }, e.i = function (t, r, n) {
          "string" === typeof t && (t = [[null, t, ""]]);
          var o = {};
          if (n) for (var i = 0; i < this.length; i++) {
            var a = this[i][0];
            null != a && (o[a] = !0);
          }

          for (var s = 0; s < t.length; s++) {
            var u = [].concat(t[s]);
            n && o[u[0]] || (r && (u[2] ? u[2] = "".concat(r, " and ").concat(u[2]) : u[2] = r), e.push(u));
          }
        }, e;
      };
    },
    2638: function _(t, e, r) {
      "use strict";

      function n() {
        return n = Object.assign || function (t) {
          for (var e, r = 1; r < arguments.length; r++) {
            for (var n in e = arguments[r], e) {
              Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }
          }

          return t;
        }, n.apply(this, arguments);
      }

      var o = ["attrs", "props", "domProps"],
          i = ["class", "style", "directives"],
          a = ["on", "nativeOn"],
          s = function s(t) {
        return t.reduce(function (t, e) {
          for (var r in e) {
            if (t[r]) {
              if (-1 !== o.indexOf(r)) t[r] = n({}, t[r], e[r]);else if (-1 !== i.indexOf(r)) {
                var s = t[r] instanceof Array ? t[r] : [t[r]],
                    l = e[r] instanceof Array ? e[r] : [e[r]];
                t[r] = s.concat(l);
              } else if (-1 !== a.indexOf(r)) for (var c in e[r]) {
                if (t[r][c]) {
                  var d = t[r][c] instanceof Array ? t[r][c] : [t[r][c]],
                      f = e[r][c] instanceof Array ? e[r][c] : [e[r][c]];
                  t[r][c] = d.concat(f);
                } else t[r][c] = e[r][c];
              } else if ("hook" == r) for (var h in e[r]) {
                t[r][h] = t[r][h] ? u(t[r][h], e[r][h]) : e[r][h];
              } else t[r] = e[r];
            } else t[r] = e[r];
          }

          return t;
        }, {});
      },
          u = function u(t, e) {
        return function () {
          t && t.apply(this, arguments), e && e.apply(this, arguments);
        };
      };

      t.exports = s;
    },
    "499e": function e(t, _e, r) {
      "use strict";

      function n(t, e) {
        for (var r = [], n = {}, o = 0; o < e.length; o++) {
          var i = e[o],
              a = i[0],
              s = i[1],
              u = i[2],
              l = i[3],
              c = {
            id: t + ":" + o,
            css: s,
            media: u,
            sourceMap: l
          };
          n[a] ? n[a].parts.push(c) : r.push(n[a] = {
            id: a,
            parts: [c]
          });
        }

        return r;
      }

      r.r(_e), r.d(_e, "default", function () {
        return p;
      });
      var o = "undefined" !== typeof document;
      if ("undefined" !== typeof DEBUG && DEBUG && !o) throw new Error("vue-style-loader cannot be used in a non-browser environment. Use { target: 'node' } in your Webpack config to indicate a server-rendering environment.");

      var i = {},
          a = o && (document.head || document.getElementsByTagName("head")[0]),
          s = null,
          u = 0,
          l = !1,
          c = function c() {},
          d = null,
          f = "data-vue-ssr-id",
          h = "undefined" !== typeof navigator && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase());

      function p(t, e, r, o) {
        l = r, d = o || {};
        var a = n(t, e);
        return y(a), function (e) {
          for (var r = [], o = 0; o < a.length; o++) {
            var s = a[o],
                u = i[s.id];
            u.refs--, r.push(u);
          }

          e ? (a = n(t, e), y(a)) : a = [];

          for (o = 0; o < r.length; o++) {
            u = r[o];

            if (0 === u.refs) {
              for (var l = 0; l < u.parts.length; l++) {
                u.parts[l]();
              }

              delete i[u.id];
            }
          }
        };
      }

      function y(t) {
        for (var e = 0; e < t.length; e++) {
          var r = t[e],
              n = i[r.id];

          if (n) {
            n.refs++;

            for (var o = 0; o < n.parts.length; o++) {
              n.parts[o](r.parts[o]);
            }

            for (; o < r.parts.length; o++) {
              n.parts.push(m(r.parts[o]));
            }

            n.parts.length > r.parts.length && (n.parts.length = r.parts.length);
          } else {
            var a = [];

            for (o = 0; o < r.parts.length; o++) {
              a.push(m(r.parts[o]));
            }

            i[r.id] = {
              id: r.id,
              refs: 1,
              parts: a
            };
          }
        }
      }

      function v() {
        var t = document.createElement("style");
        return t.type = "text/css", a.appendChild(t), t;
      }

      function m(t) {
        var e,
            r,
            n = document.querySelector("style[" + f + '~="' + t.id + '"]');

        if (n) {
          if (l) return c;
          n.parentNode.removeChild(n);
        }

        if (h) {
          var o = u++;
          n = s || (s = v()), e = g.bind(null, n, o, !1), r = g.bind(null, n, o, !0);
        } else n = v(), e = k.bind(null, n), r = function r() {
          n.parentNode.removeChild(n);
        };

        return e(t), function (n) {
          if (n) {
            if (n.css === t.css && n.media === t.media && n.sourceMap === t.sourceMap) return;
            e(t = n);
          } else r();
        };
      }

      var b = function () {
        var t = [];
        return function (e, r) {
          return t[e] = r, t.filter(Boolean).join("\n");
        };
      }();

      function g(t, e, r, n) {
        var o = r ? "" : n.css;
        if (t.styleSheet) t.styleSheet.cssText = b(e, o);else {
          var i = document.createTextNode(o),
              a = t.childNodes;
          a[e] && t.removeChild(a[e]), a.length ? t.insertBefore(i, a[e]) : t.appendChild(i);
        }
      }

      function k(t, e) {
        var r = e.css,
            n = e.media,
            o = e.sourceMap;
        if (n && t.setAttribute("media", n), d.ssrId && t.setAttribute(f, e.id), o && (r += "\n/*# sourceURL=" + o.sources[0] + " */", r += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(o)))) + " */"), t.styleSheet) t.styleSheet.cssText = r;else {
          while (t.firstChild) {
            t.removeChild(t.firstChild);
          }

          t.appendChild(document.createTextNode(r));
        }
      }
    },
    "4abb": function abb(t, e, r) {
      var n = r("7a57");
      "string" === typeof n && (n = [[t.i, n, ""]]), n.locals && (t.exports = n.locals);
      var o = r("499e")["default"];
      o("b2af7572", n, !0, {
        sourceMap: !1,
        shadowMode: !1
      });
    },
    "4ed8": function ed8(t, e, r) {
      var n = r("091b");
      "string" === typeof n && (n = [[t.i, n, ""]]), n.locals && (t.exports = n.locals);
      var o = r("499e")["default"];
      o("2f6bee1a", n, !0, {
        sourceMap: !1,
        shadowMode: !1
      });
    },
    "556c": function c(t, e, r) {
      var n = r("eef2");
      "string" === typeof n && (n = [[t.i, n, ""]]), n.locals && (t.exports = n.locals);
      var o = r("499e")["default"];
      o("1209fd47", n, !0, {
        sourceMap: !1,
        shadowMode: !1
      });
    },
    "65d9": function d9(t, e, r) {
      "use strict";
      /**
        * vue-class-component v7.0.1
        * (c) 2015-present Evan You
        * @license MIT
        */

      function n(t) {
        return t && "object" === _typeof(t) && "default" in t ? t["default"] : t;
      }

      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var o = n(r("8bbf")),
          i = "undefined" !== typeof Reflect && Reflect.defineMetadata && Reflect.getOwnMetadataKeys;

      function a(t, e) {
        s(t, e), Object.getOwnPropertyNames(e.prototype).forEach(function (r) {
          s(t.prototype, e.prototype, r);
        }), Object.getOwnPropertyNames(e).forEach(function (r) {
          s(t, e, r);
        });
      }

      function s(t, e, r) {
        var n = r ? Reflect.getOwnMetadataKeys(e, r) : Reflect.getOwnMetadataKeys(e);
        n.forEach(function (n) {
          var o = r ? Reflect.getOwnMetadata(n, e, r) : Reflect.getOwnMetadata(n, e);
          r ? Reflect.defineMetadata(n, o, t, r) : Reflect.defineMetadata(n, o, t);
        });
      }

      var u = {
        __proto__: []
      },
          l = u instanceof Array;

      function c(t) {
        return function (e, r, n) {
          var o = "function" === typeof e ? e : e.constructor;
          o.__decorators__ || (o.__decorators__ = []), "number" !== typeof n && (n = void 0), o.__decorators__.push(function (e) {
            return t(e, r, n);
          });
        };
      }

      function d() {
        for (var t = [], e = 0; e < arguments.length; e++) {
          t[e] = arguments[e];
        }

        return o.extend({
          mixins: t
        });
      }

      function f(t) {
        var e = _typeof(t);

        return null == t || "object" !== e && "function" !== e;
      }

      function h(t, e) {
        var r = e.prototype._init;

        e.prototype._init = function () {
          var e = this,
              r = Object.getOwnPropertyNames(t);
          if (t.$options.props) for (var n in t.$options.props) {
            t.hasOwnProperty(n) || r.push(n);
          }
          r.forEach(function (r) {
            "_" !== r.charAt(0) && Object.defineProperty(e, r, {
              get: function get() {
                return t[r];
              },
              set: function set(e) {
                t[r] = e;
              },
              configurable: !0
            });
          });
        };

        var n = new e();
        e.prototype._init = r;
        var o = {};
        return Object.keys(n).forEach(function (t) {
          void 0 !== n[t] && (o[t] = n[t]);
        }), o;
      }

      var p = ["data", "beforeCreate", "created", "beforeMount", "mounted", "beforeDestroy", "destroyed", "beforeUpdate", "updated", "activated", "deactivated", "render", "errorCaptured", "serverPrefetch"];

      function y(t, e) {
        void 0 === e && (e = {}), e.name = e.name || t._componentTag || t.name;
        var r = t.prototype;
        Object.getOwnPropertyNames(r).forEach(function (t) {
          if ("constructor" !== t) if (p.indexOf(t) > -1) e[t] = r[t];else {
            var n = Object.getOwnPropertyDescriptor(r, t);
            void 0 !== n.value ? "function" === typeof n.value ? (e.methods || (e.methods = {}))[t] = n.value : (e.mixins || (e.mixins = [])).push({
              data: function data() {
                var e;
                return e = {}, e[t] = n.value, e;
              }
            }) : (n.get || n.set) && ((e.computed || (e.computed = {}))[t] = {
              get: n.get,
              set: n.set
            });
          }
        }), (e.mixins || (e.mixins = [])).push({
          data: function data() {
            return h(this, t);
          }
        });
        var n = t.__decorators__;
        n && (n.forEach(function (t) {
          return t(e);
        }), delete t.__decorators__);
        var s = Object.getPrototypeOf(t.prototype),
            u = s instanceof o ? s.constructor : o,
            l = u.extend(e);
        return v(l, t, u), i && a(l, t), l;
      }

      function v(t, e, r) {
        Object.getOwnPropertyNames(e).forEach(function (n) {
          if ("prototype" !== n) {
            var o = Object.getOwnPropertyDescriptor(t, n);

            if (!o || o.configurable) {
              var i = Object.getOwnPropertyDescriptor(e, n);

              if (!l) {
                if ("cid" === n) return;
                var a = Object.getOwnPropertyDescriptor(r, n);
                if (!f(i.value) && a && a.value === i.value) return;
              }

              0, Object.defineProperty(t, n, i);
            }
          }
        });
      }

      function m(t) {
        return "function" === typeof t ? y(t) : function (e) {
          return y(e, t);
        };
      }

      m.registerHooks = function (t) {
        p.push.apply(p, t);
      }, e["default"] = m, e.createDecorator = c, e.mixins = d;
    },
    "7a57": function a57(t, e, r) {
      var n = r("24fb");
      e = n(!1), e.push([t.i, ".vue-slider{position:relative;-webkit-box-sizing:content-box;box-sizing:content-box;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;display:block;-webkit-tap-highlight-color:rgba(0,0,0,0)}.vue-slider-rail{position:relative;width:100%;height:100%;-webkit-transition-property:width,height,left,right,top,bottom;transition-property:width,height,left,right,top,bottom}.vue-slider-process{position:absolute;z-index:1}", ""]), t.exports = e;
    },
    8875: function _(t, e, r) {
      var n, o, i;

      (function (r, a) {
        o = [], n = a, i = "function" === typeof n ? n.apply(e, o) : n, void 0 === i || (t.exports = i);
      })("undefined" !== typeof self && self, function () {
        function t() {
          var e = Object.getOwnPropertyDescriptor(document, "currentScript");
          if (!e && "currentScript" in document && document.currentScript) return document.currentScript;
          if (e && e.get !== t && document.currentScript) return document.currentScript;

          try {
            throw new Error();
          } catch (h) {
            var r,
                n,
                o,
                i = /.*at [^(]*\((.*):(.+):(.+)\)$/gi,
                a = /@([^@]*):(\d+):(\d+)\s*$/gi,
                s = i.exec(h.stack) || a.exec(h.stack),
                u = s && s[1] || !1,
                l = s && s[2] || !1,
                c = document.location.href.replace(document.location.hash, ""),
                d = document.getElementsByTagName("script");
            u === c && (r = document.documentElement.outerHTML, n = new RegExp("(?:[^\\n]+?\\n){0," + (l - 2) + "}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*", "i"), o = r.replace(n, "$1").trim());

            for (var f = 0; f < d.length; f++) {
              if ("interactive" === d[f].readyState) return d[f];
              if (d[f].src === u) return d[f];
              if (u === c && d[f].innerHTML && d[f].innerHTML.trim() === o) return d[f];
            }

            return null;
          }
        }

        return t;
      });
    },
    "8bbf": function bbf(e, r) {
      e.exports = t;
    },
    eef2: function eef2(t, e, r) {
      var n = r("24fb");
      e = n(!1), e.push([t.i, ".vue-slider-marks{position:relative;width:100%;height:100%}.vue-slider-mark{position:absolute;z-index:1}.vue-slider-ltr .vue-slider-mark,.vue-slider-rtl .vue-slider-mark{width:0;height:100%;top:50%}.vue-slider-ltr .vue-slider-mark-step,.vue-slider-rtl .vue-slider-mark-step{top:0}.vue-slider-ltr .vue-slider-mark-label,.vue-slider-rtl .vue-slider-mark-label{top:100%;margin-top:10px}.vue-slider-ltr .vue-slider-mark{-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.vue-slider-ltr .vue-slider-mark-step{left:0}.vue-slider-ltr .vue-slider-mark-label{left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}.vue-slider-rtl .vue-slider-mark{-webkit-transform:translate(50%,-50%);transform:translate(50%,-50%)}.vue-slider-rtl .vue-slider-mark-step{right:0}.vue-slider-rtl .vue-slider-mark-label{right:50%;-webkit-transform:translateX(50%);transform:translateX(50%)}.vue-slider-btt .vue-slider-mark,.vue-slider-ttb .vue-slider-mark{width:100%;height:0;left:50%}.vue-slider-btt .vue-slider-mark-step,.vue-slider-ttb .vue-slider-mark-step{left:0}.vue-slider-btt .vue-slider-mark-label,.vue-slider-ttb .vue-slider-mark-label{left:100%;margin-left:10px}.vue-slider-btt .vue-slider-mark{-webkit-transform:translate(-50%,50%);transform:translate(-50%,50%)}.vue-slider-btt .vue-slider-mark-step{top:0}.vue-slider-btt .vue-slider-mark-label{top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.vue-slider-ttb .vue-slider-mark{-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.vue-slider-ttb .vue-slider-mark-step{bottom:0}.vue-slider-ttb .vue-slider-mark-label{bottom:50%;-webkit-transform:translateY(50%);transform:translateY(50%)}.vue-slider-mark-label,.vue-slider-mark-step{position:absolute}", ""]), t.exports = e;
    },
    fb15: function fb15(t, e, r) {
      "use strict";

      if (r.r(e), r.d(e, "ERROR_TYPE", function () {
        return J;
      }), r.d(e, "VueSliderMark", function () {
        return U;
      }), r.d(e, "VueSliderDot", function () {
        return j;
      }), "undefined" !== typeof window) {
        var n = window.document.currentScript,
            o = r("8875");
        n = o(), "currentScript" in document || Object.defineProperty(document, "currentScript", {
          get: o
        });
        var i = n && n.src.match(/(.+\/)[^/]+\.js(\?.*)?$/);
        i && (r.p = i[1]);
      }

      var a = r("2638"),
          s = r.n(a);

      function u(t, e, r, n) {
        var o,
            i = arguments.length,
            a = i < 3 ? e : null === n ? n = Object.getOwnPropertyDescriptor(e, r) : n;
        if ("object" === (typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) && "function" === typeof Reflect.decorate) a = Reflect.decorate(t, e, r, n);else for (var s = t.length - 1; s >= 0; s--) {
          (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, r, a) : o(e, r)) || a);
        }
        return i > 3 && a && Object.defineProperty(e, r, a), a;
      }

      var l = r("8bbf"),
          c = r.n(l),
          d = r("65d9"),
          f = r.n(d);

      function h(t, e) {
        return void 0 === e && (e = {}), Object(d["createDecorator"])(function (r, n) {
          (r.props || (r.props = {}))[n] = e, r.model = {
            prop: n,
            event: t || n
          };
        });
      }

      function p(t) {
        return void 0 === t && (t = {}), Object(d["createDecorator"])(function (e, r) {
          (e.props || (e.props = {}))[r] = t;
        });
      }

      function y(t, e) {
        void 0 === e && (e = {});
        var r = e.deep,
            n = void 0 !== r && r,
            o = e.immediate,
            i = void 0 !== o && o;
        return Object(d["createDecorator"])(function (e, r) {
          "object" !== _typeof(e.watch) && (e.watch = Object.create(null));
          var o = e.watch;
          "object" !== _typeof(o[t]) || Array.isArray(o[t]) ? "undefined" === typeof o[t] && (o[t] = []) : o[t] = [o[t]], o[t].push({
            handler: r,
            deep: n,
            immediate: i
          });
        });
      }

      r("4ed8");

      function v(t) {
        return v = "function" === typeof Symbol && "symbol" === _typeof(Symbol.iterator) ? function (t) {
          return _typeof(t);
        } : function (t) {
          return t && "function" === typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
        }, v(t);
      }

      function m(t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }

      function b(t, e) {
        for (var r = 0; r < e.length; r++) {
          var n = e[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
        }
      }

      function g(t, e, r) {
        return e && b(t.prototype, e), r && b(t, r), t;
      }

      function k(t, e) {
        if ("function" !== typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && O(t, e);
      }

      function O(t, e) {
        return O = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, O(t, e);
      }

      function x(t) {
        var e = P();
        return function () {
          var r,
              n = D(t);

          if (e) {
            var o = D(this).constructor;
            r = Reflect.construct(n, arguments, o);
          } else r = n.apply(this, arguments);

          return w(this, r);
        };
      }

      function w(t, e) {
        return !e || "object" !== v(e) && "function" !== typeof e ? S(t) : e;
      }

      function S(t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }

      function P() {
        if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" === typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }

      function D(t) {
        return D = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, D(t);
      }

      var R = function () {
        var t = function (t) {
          k(r, t);
          var e = x(r);

          function r() {
            return m(this, r), e.apply(this, arguments);
          }

          return g(r, [{
            key: "dragStart",
            value: function value(t) {
              if (this.disabled) return !1;
              this.$emit("drag-start");
            }
          }, {
            key: "render",
            value: function value() {
              var t = arguments[0];
              return t("div", {
                ref: "dot",
                "class": this.dotClasses,
                attrs: {
                  "aria-valuetext": "number" === typeof this.tooltipValue ? this.tooltipValue.toString() : this.tooltipValue
                },
                on: {
                  mousedown: this.dragStart,
                  touchstart: this.dragStart
                }
              }, [this.$slots.dot || t("div", {
                "class": this.handleClasses,
                style: this.dotStyle
              }), "none" !== this.tooltip ? t("div", {
                "class": this.tooltipClasses
              }, [this.$slots.tooltip || t("div", {
                "class": this.tooltipInnerClasses,
                style: this.tooltipStyle
              }, [t("span", {
                "class": "vue-slider-dot-tooltip-text"
              }, [this.tooltipValue])])]) : null]);
            }
          }, {
            key: "dotClasses",
            get: function get() {
              return ["vue-slider-dot", {
                "vue-slider-dot-hover": "hover" === this.tooltip || "active" === this.tooltip,
                "vue-slider-dot-disabled": this.disabled,
                "vue-slider-dot-focus": this.focus
              }];
            }
          }, {
            key: "handleClasses",
            get: function get() {
              return ["vue-slider-dot-handle", {
                "vue-slider-dot-handle-disabled": this.disabled,
                "vue-slider-dot-handle-focus": this.focus
              }];
            }
          }, {
            key: "tooltipClasses",
            get: function get() {
              return ["vue-slider-dot-tooltip", ["vue-slider-dot-tooltip-".concat(this.tooltipPlacement)], {
                "vue-slider-dot-tooltip-show": this.showTooltip
              }];
            }
          }, {
            key: "tooltipInnerClasses",
            get: function get() {
              return ["vue-slider-dot-tooltip-inner", ["vue-slider-dot-tooltip-inner-".concat(this.tooltipPlacement)], {
                "vue-slider-dot-tooltip-inner-disabled": this.disabled,
                "vue-slider-dot-tooltip-inner-focus": this.focus
              }];
            }
          }, {
            key: "showTooltip",
            get: function get() {
              switch (this.tooltip) {
                case "always":
                  return !0;

                case "none":
                  return !1;

                case "focus":
                case "active":
                  return !!this.focus;

                default:
                  return !1;
              }
            }
          }, {
            key: "tooltipValue",
            get: function get() {
              return this.tooltipFormatter ? "string" === typeof this.tooltipFormatter ? this.tooltipFormatter.replace(/\{value\}/, String(this.value)) : this.tooltipFormatter(this.value) : this.value;
            }
          }]), r;
        }(c.a);

        return u([p({
          "default": 0
        })], t.prototype, "value", void 0), u([p()], t.prototype, "tooltip", void 0), u([p()], t.prototype, "dotStyle", void 0), u([p()], t.prototype, "tooltipStyle", void 0), u([p({
          type: String,
          validator: function validator(t) {
            return ["top", "right", "bottom", "left"].indexOf(t) > -1;
          },
          required: !0
        })], t.prototype, "tooltipPlacement", void 0), u([p({
          type: [String, Function]
        })], t.prototype, "tooltipFormatter", void 0), u([p({
          type: Boolean,
          "default": !1
        })], t.prototype, "focus", void 0), u([p({
          "default": !1
        })], t.prototype, "disabled", void 0), t = u([f()({
          name: "VueSliderDot"
        })], t), t;
      }(),
          j = R;

      r("556c");

      function E(t) {
        return E = "function" === typeof Symbol && "symbol" === _typeof(Symbol.iterator) ? function (t) {
          return _typeof(t);
        } : function (t) {
          return t && "function" === typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
        }, E(t);
      }

      function A(t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }

      function V(t, e) {
        for (var r = 0; r < e.length; r++) {
          var n = e[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
        }
      }

      function M(t, e, r) {
        return e && V(t.prototype, e), r && V(t, r), t;
      }

      function _(t, e) {
        if ("function" !== typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && C(t, e);
      }

      function C(t, e) {
        return C = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, C(t, e);
      }

      function I(t) {
        var e = B();
        return function () {
          var r,
              n = N(t);

          if (e) {
            var o = N(this).constructor;
            r = Reflect.construct(n, arguments, o);
          } else r = n.apply(this, arguments);

          return L(this, r);
        };
      }

      function L(t, e) {
        return !e || "object" !== E(e) && "function" !== typeof e ? T(t) : e;
      }

      function T(t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }

      function B() {
        if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" === typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }

      function N(t) {
        return N = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, N(t);
      }

      var z,
          H = function () {
        var t = function (t) {
          _(r, t);

          var e = I(r);

          function r() {
            return A(this, r), e.apply(this, arguments);
          }

          return M(r, [{
            key: "labelClickHandle",
            value: function value(t) {
              t.stopPropagation(), this.$emit("pressLabel", this.mark.pos);
            }
          }, {
            key: "render",
            value: function value() {
              var t = arguments[0],
                  e = this.mark;
              return t("div", {
                "class": this.marksClasses
              }, [this.$slots.step || t("div", {
                "class": this.stepClasses,
                style: [this.stepStyle || {}, e.style || {}, e.active && this.stepActiveStyle || {}, e.active && e.activeStyle || {}]
              }), this.hideLabel ? null : this.$slots.label || t("div", {
                "class": this.labelClasses,
                style: [this.labelStyle || {}, e.labelStyle || {}, e.active && this.labelActiveStyle || {}, e.active && e.labelActiveStyle || {}],
                on: {
                  click: this.labelClickHandle
                }
              }, [e.label])]);
            }
          }, {
            key: "marksClasses",
            get: function get() {
              return ["vue-slider-mark", {
                "vue-slider-mark-active": this.mark.active
              }];
            }
          }, {
            key: "stepClasses",
            get: function get() {
              return ["vue-slider-mark-step", {
                "vue-slider-mark-step-active": this.mark.active
              }];
            }
          }, {
            key: "labelClasses",
            get: function get() {
              return ["vue-slider-mark-label", {
                "vue-slider-mark-label-active": this.mark.active
              }];
            }
          }]), r;
        }(c.a);

        return u([p({
          required: !0
        })], t.prototype, "mark", void 0), u([p(Boolean)], t.prototype, "hideLabel", void 0), u([p()], t.prototype, "stepStyle", void 0), u([p()], t.prototype, "stepActiveStyle", void 0), u([p()], t.prototype, "labelStyle", void 0), u([p()], t.prototype, "labelActiveStyle", void 0), t = u([f()({
          name: "VueSlideMark"
        })], t), t;
      }(),
          U = H,
          F = function F(t) {
        return "number" === typeof t ? "".concat(t, "px") : t;
      },
          $ = function $(t) {
        var e = document.documentElement,
            r = document.body,
            n = t.getBoundingClientRect(),
            o = {
          y: n.top + (window.pageYOffset || e.scrollTop) - (e.clientTop || r.clientTop || 0),
          x: n.left + (window.pageXOffset || e.scrollLeft) - (e.clientLeft || r.clientLeft || 0)
        };
        return o;
      },
          W = function W(t, e, r) {
        var n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1,
            o = "targetTouches" in t ? t.targetTouches[0] : t,
            i = $(e),
            a = {
          x: o.pageX - i.x,
          y: o.pageY - i.y
        };
        return {
          x: r ? e.offsetWidth * n - a.x : a.x,
          y: r ? e.offsetHeight * n - a.y : a.y
        };
      };

      (function (t) {
        t[t["PAGE_UP"] = 33] = "PAGE_UP", t[t["PAGE_DOWN"] = 34] = "PAGE_DOWN", t[t["END"] = 35] = "END", t[t["HOME"] = 36] = "HOME", t[t["LEFT"] = 37] = "LEFT", t[t["UP"] = 38] = "UP", t[t["RIGHT"] = 39] = "RIGHT", t[t["DOWN"] = 40] = "DOWN";
      })(z || (z = {}));

      var G = function G(t, e) {
        if (e.hook) {
          var r = e.hook(t);
          if ("function" === typeof r) return r;
          if (!r) return null;
        }

        switch (t.keyCode) {
          case z.UP:
            return function (t) {
              return "ttb" === e.direction ? t - 1 : t + 1;
            };

          case z.RIGHT:
            return function (t) {
              return "rtl" === e.direction ? t - 1 : t + 1;
            };

          case z.DOWN:
            return function (t) {
              return "ttb" === e.direction ? t + 1 : t - 1;
            };

          case z.LEFT:
            return function (t) {
              return "rtl" === e.direction ? t + 1 : t - 1;
            };

          case z.END:
            return function () {
              return e.max;
            };

          case z.HOME:
            return function () {
              return e.min;
            };

          case z.PAGE_UP:
            return function (t) {
              return t + 10;
            };

          case z.PAGE_DOWN:
            return function (t) {
              return t - 10;
            };

          default:
            return null;
        }
      };

      function X(t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }

      function q(t, e) {
        for (var r = 0; r < e.length; r++) {
          var n = e[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
        }
      }

      function K(t, e, r) {
        return e && q(t.prototype, e), r && q(t, r), t;
      }

      var Y,
          J,
          Q = function () {
        function t(e) {
          X(this, t), this.num = e;
        }

        return K(t, [{
          key: "decimal",
          value: function value(t, e) {
            var r = this.num,
                n = this.getDecimalLen(r),
                o = this.getDecimalLen(t),
                i = 0;

            switch (e) {
              case "+":
                i = this.getExponent(n, o), this.num = (this.safeRoundUp(r, i) + this.safeRoundUp(t, i)) / i;
                break;

              case "-":
                i = this.getExponent(n, o), this.num = (this.safeRoundUp(r, i) - this.safeRoundUp(t, i)) / i;
                break;

              case "*":
                this.num = this.safeRoundUp(this.safeRoundUp(r, this.getExponent(n)), this.safeRoundUp(t, this.getExponent(o))) / this.getExponent(n + o);
                break;

              case "/":
                i = this.getExponent(n, o), this.num = this.safeRoundUp(r, i) / this.safeRoundUp(t, i);
                break;

              case "%":
                i = this.getExponent(n, o), this.num = this.safeRoundUp(r, i) % this.safeRoundUp(t, i) / i;
                break;
            }

            return this;
          }
        }, {
          key: "plus",
          value: function value(t) {
            return this.decimal(t, "+");
          }
        }, {
          key: "minus",
          value: function value(t) {
            return this.decimal(t, "-");
          }
        }, {
          key: "multiply",
          value: function value(t) {
            return this.decimal(t, "*");
          }
        }, {
          key: "divide",
          value: function value(t) {
            return this.decimal(t, "/");
          }
        }, {
          key: "remainder",
          value: function value(t) {
            return this.decimal(t, "%");
          }
        }, {
          key: "toNumber",
          value: function value() {
            return this.num;
          }
        }, {
          key: "getDecimalLen",
          value: function value(t) {
            var e = "".concat(t).split("e");
            return ("".concat(e[0]).split(".")[1] || "").length - (e[1] ? +e[1] : 0);
          }
        }, {
          key: "getExponent",
          value: function value(t, e) {
            return Math.pow(10, void 0 !== e ? Math.max(t, e) : t);
          }
        }, {
          key: "safeRoundUp",
          value: function value(t, e) {
            return Math.round(t * e);
          }
        }]), t;
      }();

      function Z(t, e) {
        var r = Object.keys(t);

        if (Object.getOwnPropertySymbols) {
          var n = Object.getOwnPropertySymbols(t);
          e && (n = n.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), r.push.apply(r, n);
        }

        return r;
      }

      function tt(t) {
        for (var e = 1; e < arguments.length; e++) {
          var r = null != arguments[e] ? arguments[e] : {};
          e % 2 ? Z(Object(r), !0).forEach(function (e) {
            pt(t, e, r[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Z(Object(r)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
          });
        }

        return t;
      }

      function et(t, e) {
        return ot(t) || nt(t, e) || st(t, e) || rt();
      }

      function rt() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }

      function nt(t, e) {
        if ("undefined" !== typeof Symbol && Symbol.iterator in Object(t)) {
          var r = [],
              n = !0,
              o = !1,
              i = void 0;

          try {
            for (var a, s = t[Symbol.iterator](); !(n = (a = s.next()).done); n = !0) {
              if (r.push(a.value), e && r.length === e) break;
            }
          } catch (u) {
            o = !0, i = u;
          } finally {
            try {
              n || null == s["return"] || s["return"]();
            } finally {
              if (o) throw i;
            }
          }

          return r;
        }
      }

      function ot(t) {
        if (Array.isArray(t)) return t;
      }

      function it(t) {
        return lt(t) || ut(t) || st(t) || at();
      }

      function at() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }

      function st(t, e) {
        if (t) {
          if ("string" === typeof t) return ct(t, e);
          var r = Object.prototype.toString.call(t).slice(8, -1);
          return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? ct(t, e) : void 0;
        }
      }

      function ut(t) {
        if ("undefined" !== typeof Symbol && Symbol.iterator in Object(t)) return Array.from(t);
      }

      function lt(t) {
        if (Array.isArray(t)) return ct(t);
      }

      function ct(t, e) {
        (null == e || e > t.length) && (e = t.length);

        for (var r = 0, n = new Array(e); r < e; r++) {
          n[r] = t[r];
        }

        return n;
      }

      function dt(t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }

      function ft(t, e) {
        for (var r = 0; r < e.length; r++) {
          var n = e[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
        }
      }

      function ht(t, e, r) {
        return e && ft(t.prototype, e), r && ft(t, r), t;
      }

      function pt(t, e, r) {
        return e in t ? Object.defineProperty(t, e, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : t[e] = r, t;
      }

      (function (t) {
        t[t["VALUE"] = 1] = "VALUE", t[t["INTERVAL"] = 2] = "INTERVAL", t[t["MIN"] = 3] = "MIN", t[t["MAX"] = 4] = "MAX", t[t["ORDER"] = 5] = "ORDER";
      })(J || (J = {}));

      var yt = (Y = {}, pt(Y, J.VALUE, 'The type of the "value" is illegal'), pt(Y, J.INTERVAL, 'The prop "interval" is invalid, "(max - min)" must be divisible by "interval"'), pt(Y, J.MIN, 'The "value" must be greater than or equal to the "min".'), pt(Y, J.MAX, 'The "value" must be less than or equal to the "max".'), pt(Y, J.ORDER, 'When "order" is false, the parameters "minRange", "maxRange", "fixed", "enabled" are invalid.'), Y),
          vt = function () {
        function t(e) {
          dt(this, t), this.dotsPos = [], this.dotsValue = [], this.cacheRangeDir = {}, this.data = e.data, this.max = e.max, this.min = e.min, this.interval = e.interval, this.order = e.order, this.marks = e.marks, this.included = e.included, this.process = e.process, this.adsorb = e.adsorb, this.dotOptions = e.dotOptions, this.onError = e.onError, this.order ? (this.minRange = e.minRange || 0, this.maxRange = e.maxRange || 0, this.enableCross = e.enableCross, this.fixed = e.fixed) : ((e.minRange || e.maxRange || !e.enableCross || e.fixed) && this.emitError(J.ORDER), this.minRange = 0, this.maxRange = 0, this.enableCross = !0, this.fixed = !1), this.setValue(e.value);
        }

        return ht(t, [{
          key: "setValue",
          value: function value(t) {
            var e = this;
            this.setDotsValue(Array.isArray(t) ? this.order ? it(t).sort(function (t, r) {
              return e.getIndexByValue(t) - e.getIndexByValue(r);
            }) : it(t) : [t], !0);
          }
        }, {
          key: "setDotsValue",
          value: function value(t, e) {
            this.dotsValue = t, e && this.syncDotsPos();
          }
        }, {
          key: "setDotsPos",
          value: function value(t) {
            var e = this,
                r = this.order ? it(t).sort(function (t, e) {
              return t - e;
            }) : t;
            this.dotsPos = r, this.setDotsValue(r.map(function (t) {
              return e.getValueByPos(t);
            }), this.adsorb);
          }
        }, {
          key: "getValueByPos",
          value: function value(t) {
            var e = this.parsePos(t);

            if (this.included) {
              var r = 100;
              this.markList.forEach(function (n) {
                var o = Math.abs(n.pos - t);
                o < r && (r = o, e = n.value);
              });
            }

            return e;
          }
        }, {
          key: "syncDotsPos",
          value: function value() {
            var t = this;
            this.dotsPos = this.dotsValue.map(function (e) {
              return t.parseValue(e);
            });
          }
        }, {
          key: "getRecentDot",
          value: function value(t) {
            var e = this,
                r = this.dotsPos.filter(function (t, r) {
              return !(e.getDotOption(r) && e.getDotOption(r).disabled);
            }).map(function (e) {
              return Math.abs(e - t);
            });
            return r.indexOf(Math.min.apply(Math, it(r)));
          }
        }, {
          key: "getIndexByValue",
          value: function value(t) {
            return this.data ? this.data.indexOf(t) : new Q(+t).minus(this.min).divide(this.interval).toNumber();
          }
        }, {
          key: "getValueByIndex",
          value: function value(t) {
            return t < 0 ? t = 0 : t > this.total && (t = this.total), this.data ? this.data[t] : new Q(t).multiply(this.interval).plus(this.min).toNumber();
          }
        }, {
          key: "setDotPos",
          value: function value(t, e) {
            t = this.getValidPos(t, e).pos;
            var r = t - this.dotsPos[e];

            if (r) {
              var n = new Array(this.dotsPos.length);
              this.fixed ? n = this.getFixedChangePosArr(r, e) : this.minRange || this.maxRange ? n = this.getLimitRangeChangePosArr(t, r, e) : n[e] = r, this.setDotsPos(this.dotsPos.map(function (t, e) {
                return t + (n[e] || 0);
              }));
            }
          }
        }, {
          key: "getFixedChangePosArr",
          value: function value(t, e) {
            var r = this;
            return this.dotsPos.forEach(function (n, o) {
              if (o !== e) {
                var i = r.getValidPos(n + t, o),
                    a = i.pos,
                    s = i.inRange;
                s || (t = Math.min(Math.abs(a - n), Math.abs(t)) * (t < 0 ? -1 : 1));
              }
            }), this.dotsPos.map(function (e) {
              return t;
            });
          }
        }, {
          key: "getLimitRangeChangePosArr",
          value: function value(t, e, r) {
            var n = this,
                o = [{
              index: r,
              changePos: e
            }],
                i = e;
            return [this.minRange, this.maxRange].forEach(function (a, s) {
              if (!a) return !1;
              var u = 0 === s,
                  l = e > 0,
                  c = 0;
              c = u ? l ? 1 : -1 : l ? -1 : 1;

              var d = function d(t, e) {
                var r = Math.abs(t - e);
                return u ? r < n.minRangeDir : r > n.maxRangeDir;
              },
                  f = r + c,
                  h = n.dotsPos[f],
                  p = t;

              while (n.isPos(h) && d(h, p)) {
                var y = n.getValidPos(h + i, f),
                    v = y.pos;
                o.push({
                  index: f,
                  changePos: v - h
                }), f += c, p = v, h = n.dotsPos[f];
              }
            }), this.dotsPos.map(function (t, e) {
              var r = o.filter(function (t) {
                return t.index === e;
              });
              return r.length ? r[0].changePos : 0;
            });
          }
        }, {
          key: "isPos",
          value: function value(t) {
            return "number" === typeof t;
          }
        }, {
          key: "getValidPos",
          value: function value(t, e) {
            var r = this.valuePosRange[e],
                n = !0;
            return t < r[0] ? (t = r[0], n = !1) : t > r[1] && (t = r[1], n = !1), {
              pos: t,
              inRange: n
            };
          }
        }, {
          key: "parseValue",
          value: function value(t) {
            if (this.data) t = this.data.indexOf(t);else if ("number" === typeof t || "string" === typeof t) {
              if (t = +t, t < this.min) return this.emitError(J.MIN), 0;
              if (t > this.max) return this.emitError(J.MAX), 0;
              if ("number" !== typeof t || t !== t) return this.emitError(J.VALUE), 0;
              t = new Q(t).minus(this.min).divide(this.interval).toNumber();
            }
            var e = new Q(t).multiply(this.gap).toNumber();
            return e < 0 ? 0 : e > 100 ? 100 : e;
          }
        }, {
          key: "parsePos",
          value: function value(t) {
            var e = Math.round(t / this.gap);
            return this.getValueByIndex(e);
          }
        }, {
          key: "isActiveByPos",
          value: function value(t) {
            return this.processArray.some(function (e) {
              var r = et(e, 2),
                  n = r[0],
                  o = r[1];
              return t >= n && t <= o;
            });
          }
        }, {
          key: "getValues",
          value: function value() {
            if (this.data) return this.data;

            for (var t = [], e = 0; e <= this.total; e++) {
              t.push(new Q(e).multiply(this.interval).plus(this.min).toNumber());
            }

            return t;
          }
        }, {
          key: "getRangeDir",
          value: function value(t) {
            return t ? new Q(t).divide(new Q(this.data ? this.data.length - 1 : this.max).minus(this.data ? 0 : this.min).toNumber()).multiply(100).toNumber() : 100;
          }
        }, {
          key: "emitError",
          value: function value(t) {
            this.onError && this.onError(t, yt[t]);
          }
        }, {
          key: "getDotOption",
          value: function value(t) {
            return Array.isArray(this.dotOptions) ? this.dotOptions[t] : this.dotOptions;
          }
        }, {
          key: "getDotRange",
          value: function value(t, e, r) {
            if (!this.dotOptions) return r;
            var n = this.getDotOption(t);
            return n && void 0 !== n[e] ? this.parseValue(n[e]) : r;
          }
        }, {
          key: "markList",
          get: function get() {
            var t = this;
            if (!this.marks) return [];

            var e = function e(_e2, r) {
              var n = t.parseValue(_e2);
              return tt({
                pos: n,
                value: _e2,
                label: _e2,
                active: t.isActiveByPos(n)
              }, r);
            };

            return !0 === this.marks ? this.getValues().map(function (t) {
              return e(t);
            }) : "[object Object]" === Object.prototype.toString.call(this.marks) ? Object.keys(this.marks).sort(function (t, e) {
              return +t - +e;
            }).map(function (r) {
              var n = t.marks[r];
              return e(r, "string" !== typeof n ? n : {
                label: n
              });
            }) : Array.isArray(this.marks) ? this.marks.map(function (t) {
              return e(t);
            }) : "function" === typeof this.marks ? this.getValues().map(function (e) {
              return {
                value: e,
                result: t.marks(e)
              };
            }).filter(function (t) {
              var e = t.result;
              return !!e;
            }).map(function (t) {
              var r = t.value,
                  n = t.result;
              return e(r, n);
            }) : [];
          }
        }, {
          key: "processArray",
          get: function get() {
            if (this.process) {
              if ("function" === typeof this.process) return this.process(this.dotsPos);
              if (1 === this.dotsPos.length) return [[0, this.dotsPos[0]]];
              if (this.dotsPos.length > 1) return [[Math.min.apply(Math, it(this.dotsPos)), Math.max.apply(Math, it(this.dotsPos))]];
            }

            return [];
          }
        }, {
          key: "total",
          get: function get() {
            var t = 0;
            return t = this.data ? this.data.length - 1 : new Q(this.max).minus(this.min).divide(this.interval).toNumber(), t - Math.floor(t) !== 0 ? (this.emitError(J.INTERVAL), 0) : t;
          }
        }, {
          key: "gap",
          get: function get() {
            return 100 / this.total;
          }
        }, {
          key: "minRangeDir",
          get: function get() {
            return this.cacheRangeDir[this.minRange] ? this.cacheRangeDir[this.minRange] : this.cacheRangeDir[this.minRange] = this.getRangeDir(this.minRange);
          }
        }, {
          key: "maxRangeDir",
          get: function get() {
            return this.cacheRangeDir[this.maxRange] ? this.cacheRangeDir[this.maxRange] : this.cacheRangeDir[this.maxRange] = this.getRangeDir(this.maxRange);
          }
        }, {
          key: "valuePosRange",
          get: function get() {
            var t = this,
                e = this.dotsPos,
                r = [];
            return e.forEach(function (n, o) {
              r.push([Math.max(t.minRange ? t.minRangeDir * o : 0, t.enableCross ? 0 : e[o - 1] || 0, t.getDotRange(o, "min", 0)), Math.min(t.minRange ? 100 - t.minRangeDir * (e.length - 1 - o) : 100, t.enableCross ? 100 : e[o + 1] || 100, t.getDotRange(o, "max", 100))]);
            }), r;
          }
        }, {
          key: "dotsIndex",
          get: function get() {
            var t = this;
            return this.dotsValue.map(function (e) {
              return t.getIndexByValue(e);
            });
          }
        }]), t;
      }();

      function mt(t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }

      function bt(t, e) {
        for (var r = 0; r < e.length; r++) {
          var n = e[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
        }
      }

      function gt(t, e, r) {
        return e && bt(t.prototype, e), r && bt(t, r), t;
      }

      var kt = function () {
        function t(e) {
          mt(this, t), this.states = 0, this.map = e;
        }

        return gt(t, [{
          key: "add",
          value: function value(t) {
            this.states |= t;
          }
        }, {
          key: "delete",
          value: function value(t) {
            this.states &= ~t;
          }
        }, {
          key: "toggle",
          value: function value(t) {
            this.has(t) ? this["delete"](t) : this.add(t);
          }
        }, {
          key: "has",
          value: function value(t) {
            return !!(this.states & t);
          }
        }]), t;
      }();

      r("4abb");

      function Ot(t, e) {
        return St(t) || wt(t, e) || At(t, e) || xt();
      }

      function xt() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }

      function wt(t, e) {
        if ("undefined" !== typeof Symbol && Symbol.iterator in Object(t)) {
          var r = [],
              n = !0,
              o = !1,
              i = void 0;

          try {
            for (var a, s = t[Symbol.iterator](); !(n = (a = s.next()).done); n = !0) {
              if (r.push(a.value), e && r.length === e) break;
            }
          } catch (u) {
            o = !0, i = u;
          } finally {
            try {
              n || null == s["return"] || s["return"]();
            } finally {
              if (o) throw i;
            }
          }

          return r;
        }
      }

      function St(t) {
        if (Array.isArray(t)) return t;
      }

      function Pt(t, e) {
        var r = Object.keys(t);

        if (Object.getOwnPropertySymbols) {
          var n = Object.getOwnPropertySymbols(t);
          e && (n = n.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), r.push.apply(r, n);
        }

        return r;
      }

      function Dt(t) {
        for (var e = 1; e < arguments.length; e++) {
          var r = null != arguments[e] ? arguments[e] : {};
          e % 2 ? Pt(Object(r), !0).forEach(function (e) {
            Rt(t, e, r[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Pt(Object(r)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
          });
        }

        return t;
      }

      function Rt(t, e, r) {
        return e in t ? Object.defineProperty(t, e, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : t[e] = r, t;
      }

      function jt(t) {
        return Mt(t) || Vt(t) || At(t) || Et();
      }

      function Et() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }

      function At(t, e) {
        if (t) {
          if ("string" === typeof t) return _t(t, e);
          var r = Object.prototype.toString.call(t).slice(8, -1);
          return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? _t(t, e) : void 0;
        }
      }

      function Vt(t) {
        if ("undefined" !== typeof Symbol && Symbol.iterator in Object(t)) return Array.from(t);
      }

      function Mt(t) {
        if (Array.isArray(t)) return _t(t);
      }

      function _t(t, e) {
        (null == e || e > t.length) && (e = t.length);

        for (var r = 0, n = new Array(e); r < e; r++) {
          n[r] = t[r];
        }

        return n;
      }

      function Ct(t) {
        return Ct = "function" === typeof Symbol && "symbol" === _typeof(Symbol.iterator) ? function (t) {
          return _typeof(t);
        } : function (t) {
          return t && "function" === typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
        }, Ct(t);
      }

      function It(t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }

      function Lt(t, e) {
        for (var r = 0; r < e.length; r++) {
          var n = e[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
        }
      }

      function Tt(t, e, r) {
        return e && Lt(t.prototype, e), r && Lt(t, r), t;
      }

      function Bt(t, e) {
        if ("function" !== typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Nt(t, e);
      }

      function Nt(t, e) {
        return Nt = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, Nt(t, e);
      }

      function zt(t) {
        var e = Ft();
        return function () {
          var r,
              n = $t(t);

          if (e) {
            var o = $t(this).constructor;
            r = Reflect.construct(n, arguments, o);
          } else r = n.apply(this, arguments);

          return Ht(this, r);
        };
      }

      function Ht(t, e) {
        return !e || "object" !== Ct(e) && "function" !== typeof e ? Ut(t) : e;
      }

      function Ut(t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }

      function Ft() {
        if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" === typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }

      function $t(t) {
        return $t = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, $t(t);
      }

      var Wt = {
        None: 0,
        Drag: 2,
        Focus: 4
      },
          Gt = 4,
          Xt = function () {
        var t = function (t) {
          Bt(r, t);
          var e = zt(r);

          function r() {
            var t;
            return It(this, r), t = e.apply(this, arguments), t.states = new kt(Wt), t.scale = 1, t.focusDotIndex = 0, t;
          }

          return Tt(r, [{
            key: "isObjectData",
            value: function value(t) {
              return !!t && "[object Object]" === Object.prototype.toString.call(t);
            }
          }, {
            key: "isObjectArrayData",
            value: function value(t) {
              return !!t && Array.isArray(t) && t.length > 0 && "object" === Ct(t[0]);
            }
          }, {
            key: "onValueChanged",
            value: function value() {
              this.control && !this.states.has(Wt.Drag) && this.isNotSync && (this.control.setValue(this.value), this.syncValueByPos());
            }
          }, {
            key: "created",
            value: function value() {
              this.initControl();
            }
          }, {
            key: "mounted",
            value: function value() {
              this.bindEvent();
            }
          }, {
            key: "beforeDestroy",
            value: function value() {
              this.unbindEvent();
            }
          }, {
            key: "bindEvent",
            value: function value() {
              document.addEventListener("touchmove", this.dragMove, {
                passive: !1
              }), document.addEventListener("touchend", this.dragEnd, {
                passive: !1
              }), document.addEventListener("mousedown", this.blurHandle), document.addEventListener("mousemove", this.dragMove, {
                passive: !1
              }), document.addEventListener("mouseup", this.dragEnd), document.addEventListener("mouseleave", this.dragEnd), document.addEventListener("keydown", this.keydownHandle);
            }
          }, {
            key: "unbindEvent",
            value: function value() {
              document.removeEventListener("touchmove", this.dragMove), document.removeEventListener("touchend", this.dragEnd), document.removeEventListener("mousedown", this.blurHandle), document.removeEventListener("mousemove", this.dragMove), document.removeEventListener("mouseup", this.dragEnd), document.removeEventListener("mouseleave", this.dragEnd), document.removeEventListener("keydown", this.keydownHandle);
            }
          }, {
            key: "setScale",
            value: function value() {
              var t = new Q(Math.floor(this.isHorizontal ? this.$refs.rail.offsetWidth : this.$refs.rail.offsetHeight));
              void 0 !== this.zoom && t.multiply(this.zoom), t.divide(100), this.scale = t.toNumber();
            }
          }, {
            key: "initControl",
            value: function value() {
              var t = this;
              this.control = new vt({
                value: this.value,
                data: this.sliderData,
                enableCross: this.enableCross,
                fixed: this.fixed,
                max: this.max,
                min: this.min,
                interval: this.interval,
                minRange: this.minRange,
                maxRange: this.maxRange,
                order: this.order,
                marks: this.sliderMarks,
                included: this.included,
                process: this.process,
                adsorb: this.adsorb,
                dotOptions: this.dotOptions,
                onError: this.emitError
              }), this.syncValueByPos(), ["data", "enableCross", "fixed", "max", "min", "interval", "minRange", "maxRange", "order", "marks", "process", "adsorb", "included", "dotOptions"].forEach(function (e) {
                t.$watch(e, function (r) {
                  if ("data" === e && Array.isArray(t.control.data) && Array.isArray(r) && t.control.data.length === r.length && r.every(function (e, r) {
                    return e === t.control.data[r];
                  })) return !1;

                  switch (e) {
                    case "data":
                    case "dataLabel":
                    case "dataValue":
                      t.control.data = t.sliderData;
                      break;

                    case "mark":
                      t.control.marks = t.sliderMarks;
                      break;

                    default:
                      t.control[e] = r;
                  }

                  ["data", "max", "min", "interval"].indexOf(e) > -1 && t.control.syncDotsPos();
                });
              });
            }
          }, {
            key: "syncValueByPos",
            value: function value() {
              var t = this.control.dotsValue;
              this.isDiff(t, Array.isArray(this.value) ? this.value : [this.value]) && this.$emit("change", 1 === t.length ? t[0] : jt(t), this.focusDotIndex);
            }
          }, {
            key: "isDiff",
            value: function value(t, e) {
              return t.length !== e.length || t.some(function (t, r) {
                return t !== e[r];
              });
            }
          }, {
            key: "emitError",
            value: function value(t, e) {
              this.silent || console.error("[VueSlider error]: ".concat(e)), this.$emit("error", t, e);
            }
          }, {
            key: "dragStartOnProcess",
            value: function value(t) {
              if (this.dragOnClick) {
                this.setScale();
                var e = this.getPosByEvent(t),
                    r = this.control.getRecentDot(e);
                if (this.dots[r].disabled) return;
                this.dragStart(r), this.control.setDotPos(e, this.focusDotIndex), this.lazy || this.syncValueByPos();
              }
            }
          }, {
            key: "dragStart",
            value: function value(t) {
              this.focusDotIndex = t, this.setScale(), this.states.add(Wt.Drag), this.states.add(Wt.Focus), this.$emit("drag-start", this.focusDotIndex);
            }
          }, {
            key: "dragMove",
            value: function value(t) {
              if (!this.states.has(Wt.Drag)) return !1;
              t.preventDefault();
              var e = this.getPosByEvent(t);
              this.isCrossDot(e), this.control.setDotPos(e, this.focusDotIndex), this.lazy || this.syncValueByPos();
              var r = this.control.dotsValue;
              this.$emit("dragging", 1 === r.length ? r[0] : jt(r), this.focusDotIndex);
            }
          }, {
            key: "isCrossDot",
            value: function value(t) {
              if (this.canSort) {
                var e = this.focusDotIndex,
                    r = t;

                if (r > this.dragRange[1] ? (r = this.dragRange[1], this.focusDotIndex++) : r < this.dragRange[0] && (r = this.dragRange[0], this.focusDotIndex--), e !== this.focusDotIndex) {
                  var n = this.$refs["dot-".concat(this.focusDotIndex)];
                  n && n.$el && n.$el.focus(), this.control.setDotPos(r, e);
                }
              }
            }
          }, {
            key: "dragEnd",
            value: function value(t) {
              var e = this;
              if (!this.states.has(Wt.Drag)) return !1;
              setTimeout(function () {
                e.lazy && e.syncValueByPos(), e.included && e.isNotSync ? e.control.setValue(e.value) : e.control.syncDotsPos(), e.states["delete"](Wt.Drag), e.useKeyboard && !("targetTouches" in t) || e.states["delete"](Wt.Focus), e.$emit("drag-end", e.focusDotIndex);
              });
            }
          }, {
            key: "blurHandle",
            value: function value(t) {
              if (!this.states.has(Wt.Focus) || !this.$refs.container || this.$refs.container.contains(t.target)) return !1;
              this.states["delete"](Wt.Focus);
            }
          }, {
            key: "clickHandle",
            value: function value(t) {
              if (!this.clickable || this.disabled) return !1;

              if (!this.states.has(Wt.Drag)) {
                this.setScale();
                var e = this.getPosByEvent(t);
                this.setValueByPos(e);
              }
            }
          }, {
            key: "focus",
            value: function value() {
              var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
              this.states.add(Wt.Focus), this.focusDotIndex = t;
            }
          }, {
            key: "blur",
            value: function value() {
              this.states["delete"](Wt.Focus);
            }
          }, {
            key: "getValue",
            value: function value() {
              var t = this.control.dotsValue;
              return 1 === t.length ? t[0] : t;
            }
          }, {
            key: "getIndex",
            value: function value() {
              var t = this.control.dotsIndex;
              return 1 === t.length ? t[0] : t;
            }
          }, {
            key: "setValue",
            value: function value(t) {
              this.control.setValue(Array.isArray(t) ? jt(t) : [t]), this.syncValueByPos();
            }
          }, {
            key: "setIndex",
            value: function value(t) {
              var e = this,
                  r = Array.isArray(t) ? t.map(function (t) {
                return e.control.getValueByIndex(t);
              }) : this.control.getValueByIndex(t);
              this.setValue(r);
            }
          }, {
            key: "setValueByPos",
            value: function value(t) {
              var e = this,
                  r = this.control.getRecentDot(t);
              if (this.disabled || this.dots[r].disabled) return !1;
              this.focusDotIndex = r, this.control.setDotPos(t, r), this.syncValueByPos(), this.useKeyboard && this.states.add(Wt.Focus), setTimeout(function () {
                e.included && e.isNotSync ? e.control.setValue(e.value) : e.control.syncDotsPos();
              });
            }
          }, {
            key: "keydownHandle",
            value: function value(t) {
              var e = this;
              if (!this.useKeyboard || !this.states.has(Wt.Focus)) return !1;
              var r = this.included && this.marks,
                  n = G(t, {
                direction: this.direction,
                max: r ? this.control.markList.length - 1 : this.control.total,
                min: 0,
                hook: this.keydownHook
              });

              if (n) {
                t.preventDefault();
                var o = -1,
                    i = 0;
                r ? (this.control.markList.some(function (t, r) {
                  return t.value === e.control.dotsValue[e.focusDotIndex] && (o = n(r), !0);
                }), o < 0 ? o = 0 : o > this.control.markList.length - 1 && (o = this.control.markList.length - 1), i = this.control.markList[o].pos) : (o = n(this.control.getIndexByValue(this.control.dotsValue[this.focusDotIndex])), i = this.control.parseValue(this.control.getValueByIndex(o))), this.isCrossDot(i), this.control.setDotPos(i, this.focusDotIndex), this.syncValueByPos();
              }
            }
          }, {
            key: "getPosByEvent",
            value: function value(t) {
              return W(t, this.$refs.rail, this.isReverse, this.zoom)[this.isHorizontal ? "x" : "y"] / this.scale;
            }
          }, {
            key: "renderSlot",
            value: function value(t, e, r, n) {
              var o = this.$createElement,
                  i = this.$scopedSlots[t];
              return i ? n ? i(e) : o("template", {
                slot: t
              }, [i(e)]) : r;
            }
          }, {
            key: "render",
            value: function value() {
              var t = this,
                  e = arguments[0];
              return e("div", s()([{
                ref: "container",
                "class": this.containerClasses,
                style: this.containerStyles,
                on: {
                  click: this.clickHandle,
                  touchstart: this.dragStartOnProcess,
                  mousedown: this.dragStartOnProcess
                }
              }, this.$attrs]), [e("div", {
                ref: "rail",
                "class": "vue-slider-rail",
                style: this.railStyle
              }, [this.processArray.map(function (r, n) {
                return t.renderSlot("process", r, e("div", {
                  "class": "vue-slider-process",
                  key: "process-".concat(n),
                  style: r.style
                }), !0);
              }), this.sliderMarks ? e("div", {
                "class": "vue-slider-marks"
              }, [this.control.markList.map(function (r, n) {
                var o;
                return t.renderSlot("mark", r, e("vue-slider-mark", {
                  key: "mark-".concat(n),
                  attrs: {
                    mark: r,
                    hideLabel: t.hideLabel,
                    stepStyle: t.stepStyle,
                    stepActiveStyle: t.stepActiveStyle,
                    labelStyle: t.labelStyle,
                    labelActiveStyle: t.labelActiveStyle
                  },
                  style: (o = {}, Rt(o, t.isHorizontal ? "height" : "width", "100%"), Rt(o, t.isHorizontal ? "width" : "height", t.tailSize), Rt(o, t.mainDirection, "".concat(r.pos, "%")), o),
                  on: {
                    pressLabel: function pressLabel(e) {
                      return t.clickable && t.setValueByPos(e);
                    }
                  }
                }, [t.renderSlot("step", r, null), t.renderSlot("label", r, null)]), !0);
              })]) : null, this.dots.map(function (r, n) {
                var o;
                return e("vue-slider-dot", {
                  ref: "dot-".concat(n),
                  key: "dot-".concat(n),
                  attrs: Dt({
                    value: r.value,
                    disabled: r.disabled,
                    focus: r.focus,
                    "dot-style": [r.style, r.disabled ? r.disabledStyle : null, r.focus ? r.focusStyle : null],
                    tooltip: r.tooltip || t.tooltip,
                    "tooltip-style": [t.tooltipStyle, r.tooltipStyle, r.disabled ? r.tooltipDisabledStyle : null, r.focus ? r.tooltipFocusStyle : null],
                    "tooltip-formatter": Array.isArray(t.sliderTooltipFormatter) ? t.sliderTooltipFormatter[n] : t.sliderTooltipFormatter,
                    "tooltip-placement": t.tooltipDirections[n],
                    role: "slider",
                    "aria-valuenow": r.value,
                    "aria-valuemin": t.min,
                    "aria-valuemax": t.max,
                    "aria-orientation": t.isHorizontal ? "horizontal" : "vertical",
                    tabindex: "0"
                  }, t.dotAttrs),
                  style: [t.dotBaseStyle, (o = {}, Rt(o, t.mainDirection, "".concat(r.pos, "%")), Rt(o, "transition", "".concat(t.mainDirection, " ").concat(t.animateTime, "s")), o)],
                  on: {
                    "drag-start": function dragStart() {
                      return t.dragStart(n);
                    }
                  },
                  nativeOn: {
                    focus: function focus() {
                      return !r.disabled && t.focus(n);
                    },
                    blur: function blur() {
                      return t.blur();
                    }
                  }
                }, [t.renderSlot("dot", r, null), t.renderSlot("tooltip", r, null)]);
              }), this.renderSlot("default", {
                value: this.getValue()
              }, null, !0)])]);
            }
          }, {
            key: "tailSize",
            get: function get() {
              return F((this.isHorizontal ? this.height : this.width) || Gt);
            }
          }, {
            key: "containerClasses",
            get: function get() {
              return ["vue-slider", ["vue-slider-".concat(this.direction)], {
                "vue-slider-disabled": this.disabled
              }];
            }
          }, {
            key: "containerStyles",
            get: function get() {
              var t = Array.isArray(this.dotSize) ? this.dotSize : [this.dotSize, this.dotSize],
                  e = Ot(t, 2),
                  r = e[0],
                  n = e[1],
                  o = this.width ? F(this.width) : this.isHorizontal ? "auto" : F(Gt),
                  i = this.height ? F(this.height) : this.isHorizontal ? F(Gt) : "auto";
              return {
                padding: this.contained ? "".concat(n / 2, "px ").concat(r / 2, "px") : this.isHorizontal ? "".concat(n / 2, "px 0") : "0 ".concat(r / 2, "px"),
                width: o,
                height: i
              };
            }
          }, {
            key: "processArray",
            get: function get() {
              var t = this;
              return this.control.processArray.map(function (e, r) {
                var n,
                    o = Ot(e, 3),
                    i = o[0],
                    a = o[1],
                    s = o[2];

                if (i > a) {
                  var u = [a, i];
                  i = u[0], a = u[1];
                }

                var l = t.isHorizontal ? "width" : "height";
                return {
                  start: i,
                  end: a,
                  index: r,
                  style: Dt(Dt((n = {}, Rt(n, t.isHorizontal ? "height" : "width", "100%"), Rt(n, t.isHorizontal ? "top" : "left", 0), Rt(n, t.mainDirection, "".concat(i, "%")), Rt(n, l, "".concat(a - i, "%")), Rt(n, "transitionProperty", "".concat(l, ",").concat(t.mainDirection)), Rt(n, "transitionDuration", "".concat(t.animateTime, "s")), n), t.processStyle), s)
                };
              });
            }
          }, {
            key: "dotBaseStyle",
            get: function get() {
              var t,
                  e = Array.isArray(this.dotSize) ? this.dotSize : [this.dotSize, this.dotSize],
                  r = Ot(e, 2),
                  n = r[0],
                  o = r[1];
              return t = this.isHorizontal ? Rt({
                transform: "translate(".concat(this.isReverse ? "50%" : "-50%", ", -50%)"),
                "-WebkitTransform": "translate(".concat(this.isReverse ? "50%" : "-50%", ", -50%)"),
                top: "50%"
              }, "ltr" === this.direction ? "left" : "right", "0") : Rt({
                transform: "translate(-50%, ".concat(this.isReverse ? "50%" : "-50%", ")"),
                "-WebkitTransform": "translate(-50%, ".concat(this.isReverse ? "50%" : "-50%", ")"),
                left: "50%"
              }, "btt" === this.direction ? "bottom" : "top", "0"), Dt({
                width: "".concat(n, "px"),
                height: "".concat(o, "px")
              }, t);
            }
          }, {
            key: "mainDirection",
            get: function get() {
              switch (this.direction) {
                case "ltr":
                  return "left";

                case "rtl":
                  return "right";

                case "btt":
                  return "bottom";

                case "ttb":
                  return "top";
              }
            }
          }, {
            key: "isHorizontal",
            get: function get() {
              return "ltr" === this.direction || "rtl" === this.direction;
            }
          }, {
            key: "isReverse",
            get: function get() {
              return "rtl" === this.direction || "btt" === this.direction;
            }
          }, {
            key: "tooltipDirections",
            get: function get() {
              var t = this.tooltipPlacement || (this.isHorizontal ? "top" : "left");
              return Array.isArray(t) ? t : this.dots.map(function () {
                return t;
              });
            }
          }, {
            key: "dots",
            get: function get() {
              var t = this;
              return this.control.dotsPos.map(function (e, r) {
                return Dt({
                  pos: e,
                  index: r,
                  value: t.control.dotsValue[r],
                  focus: t.states.has(Wt.Focus) && t.focusDotIndex === r,
                  disabled: t.disabled,
                  style: t.dotStyle
                }, (Array.isArray(t.dotOptions) ? t.dotOptions[r] : t.dotOptions) || {});
              });
            }
          }, {
            key: "animateTime",
            get: function get() {
              return this.states.has(Wt.Drag) ? 0 : this.duration;
            }
          }, {
            key: "canSort",
            get: function get() {
              return this.order && !this.minRange && !this.maxRange && !this.fixed && this.enableCross;
            }
          }, {
            key: "sliderData",
            get: function get() {
              var t = this;
              return this.isObjectArrayData(this.data) ? this.data.map(function (e) {
                return e[t.dataValue];
              }) : this.isObjectData(this.data) ? Object.keys(this.data) : this.data;
            }
          }, {
            key: "sliderMarks",
            get: function get() {
              var t = this;
              return this.marks ? this.marks : this.isObjectArrayData(this.data) ? function (e) {
                var r = {
                  label: e
                };
                return t.data.some(function (n) {
                  return n[t.dataValue] === e && (r.label = n[t.dataLabel], !0);
                }), r;
              } : this.isObjectData(this.data) ? this.data : void 0;
            }
          }, {
            key: "sliderTooltipFormatter",
            get: function get() {
              var t = this;
              if (this.tooltipFormatter) return this.tooltipFormatter;
              if (this.isObjectArrayData(this.data)) return function (e) {
                var r = "" + e;
                return t.data.some(function (n) {
                  return n[t.dataValue] === e && (r = n[t.dataLabel], !0);
                }), r;
              };

              if (this.isObjectData(this.data)) {
                var e = this.data;
                return function (t) {
                  return e[t];
                };
              }
            }
          }, {
            key: "isNotSync",
            get: function get() {
              var t = this.control.dotsValue;
              return Array.isArray(this.value) ? this.value.length !== t.length || this.value.some(function (e, r) {
                return e !== t[r];
              }) : this.value !== t[0];
            }
          }, {
            key: "dragRange",
            get: function get() {
              var t = this.dots[this.focusDotIndex - 1],
                  e = this.dots[this.focusDotIndex + 1];
              return [t ? t.pos : -1 / 0, e ? e.pos : 1 / 0];
            }
          }]), r;
        }(c.a);

        return u([h("change", {
          "default": 0
        })], t.prototype, "value", void 0), u([p({
          type: Boolean,
          "default": !1
        })], t.prototype, "silent", void 0), u([p({
          "default": "ltr",
          validator: function validator(t) {
            return ["ltr", "rtl", "ttb", "btt"].indexOf(t) > -1;
          }
        })], t.prototype, "direction", void 0), u([p({
          type: [Number, String]
        })], t.prototype, "width", void 0), u([p({
          type: [Number, String]
        })], t.prototype, "height", void 0), u([p({
          "default": 14
        })], t.prototype, "dotSize", void 0), u([p({
          "default": !1
        })], t.prototype, "contained", void 0), u([p({
          type: Number,
          "default": 0
        })], t.prototype, "min", void 0), u([p({
          type: Number,
          "default": 100
        })], t.prototype, "max", void 0), u([p({
          type: Number,
          "default": 1
        })], t.prototype, "interval", void 0), u([p({
          type: Boolean,
          "default": !1
        })], t.prototype, "disabled", void 0), u([p({
          type: Boolean,
          "default": !0
        })], t.prototype, "clickable", void 0), u([p({
          type: Boolean,
          "default": !1
        })], t.prototype, "dragOnClick", void 0), u([p({
          type: Number,
          "default": .5
        })], t.prototype, "duration", void 0), u([p({
          type: [Object, Array]
        })], t.prototype, "data", void 0), u([p({
          type: String,
          "default": "value"
        })], t.prototype, "dataValue", void 0), u([p({
          type: String,
          "default": "label"
        })], t.prototype, "dataLabel", void 0), u([p({
          type: Boolean,
          "default": !1
        })], t.prototype, "lazy", void 0), u([p({
          type: String,
          validator: function validator(t) {
            return ["none", "always", "focus", "hover", "active"].indexOf(t) > -1;
          },
          "default": "active"
        })], t.prototype, "tooltip", void 0), u([p({
          type: [String, Array],
          validator: function validator(t) {
            return (Array.isArray(t) ? t : [t]).every(function (t) {
              return ["top", "right", "bottom", "left"].indexOf(t) > -1;
            });
          }
        })], t.prototype, "tooltipPlacement", void 0), u([p({
          type: [String, Array, Function]
        })], t.prototype, "tooltipFormatter", void 0), u([p({
          type: Boolean,
          "default": !0
        })], t.prototype, "useKeyboard", void 0), u([p(Function)], t.prototype, "keydownHook", void 0), u([p({
          type: Boolean,
          "default": !0
        })], t.prototype, "enableCross", void 0), u([p({
          type: Boolean,
          "default": !1
        })], t.prototype, "fixed", void 0), u([p({
          type: Boolean,
          "default": !0
        })], t.prototype, "order", void 0), u([p(Number)], t.prototype, "minRange", void 0), u([p(Number)], t.prototype, "maxRange", void 0), u([p({
          type: [Boolean, Object, Array, Function],
          "default": !1
        })], t.prototype, "marks", void 0), u([p({
          type: [Boolean, Function],
          "default": !0
        })], t.prototype, "process", void 0), u([p({
          type: [Number]
        })], t.prototype, "zoom", void 0), u([p(Boolean)], t.prototype, "included", void 0), u([p(Boolean)], t.prototype, "adsorb", void 0), u([p(Boolean)], t.prototype, "hideLabel", void 0), u([p()], t.prototype, "dotOptions", void 0), u([p()], t.prototype, "dotAttrs", void 0), u([p()], t.prototype, "railStyle", void 0), u([p()], t.prototype, "processStyle", void 0), u([p()], t.prototype, "dotStyle", void 0), u([p()], t.prototype, "tooltipStyle", void 0), u([p()], t.prototype, "stepStyle", void 0), u([p()], t.prototype, "stepActiveStyle", void 0), u([p()], t.prototype, "labelStyle", void 0), u([p()], t.prototype, "labelActiveStyle", void 0), u([y("value")], t.prototype, "onValueChanged", null), t = u([f()({
          name: "VueSlider",
          data: function data() {
            return {
              control: null
            };
          },
          components: {
            VueSliderDot: j,
            VueSliderMark: U
          }
        })], t), t;
      }(),
          qt = Xt;

      qt.VueSliderMark = U, qt.VueSliderDot = j;
      var Kt = qt;
      e["default"] = Kt;
    }
  })["default"];
});